/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { submitUpdate } from "../../../actions/agencyProfileActions";
import Warning from "./Warning";
import {
  Wrapper,
  CloseButton,
  Form,
  EditorWrapper,
  CharLimitExceeded,
  Buttons,
  SaveButton,
} from "./styles/about-company-edit-styles";

export class AboutCompanyEdit extends Component {
  constructor(props) {
    super(props);
    const { aboutCompany } = this.props;

    this.state = {
      editorState: aboutCompany
        ? EditorState.createWithContent(
            ContentState.createFromBlockArray(convertFromHTML(aboutCompany))
          )
        : "",
      aboutCompany,
      warningActive: false,
    };
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  editorOnChange = (editorState) => {
    let html = stateToHTML(editorState.getCurrentContent());
    if (html === "<p><br></p>") {
      html = "";
    }
    this.setState({ aboutCompany: html, characterCount: html.length });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitUpdate, companyId, toggleEditAboutCompany } = this.props;
    const { aboutCompany } = this.state;

    submitUpdate(
      { aboutCompany, companyId },
      toggleEditAboutCompany,
      "ABOUT_COMPANY"
    );
  };

  render() {
    const { toggleEditAboutCompany } = this.props;
    const { warningActive, editorState, characterCount } = this.state;

    return (
      <Wrapper>
        {warningActive && (
          <Warning
            toggleWarning={this.toggleWarning}
            closeForm={toggleEditAboutCompany}
          />
        )}
        <CloseButton onClick={() => this.toggleWarning()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Form>
          <EditorWrapper>
            <Editor
              ref={this.editor}
              toolbarClassName="editor-toolbar"
              editorClassName="editor"
              editorState={editorState}
              onEditorStateChange={this.onEditorStateChange}
              onChange={() => this.editorOnChange(editorState)}
              toolbar={{
                options: ["inline", "list"],
                inline: {
                  options: ["bold", "italic", "underline", "strikethrough"],
                },
                list: {
                  options: ["unordered", "ordered"],
                },
              }}
            />
          </EditorWrapper>
          {characterCount > 10000 && (
            <CharLimitExceeded data-test-id="char-limit-exc">
              <FontAwesomeIcon icon={faInfoCircle} />
              Character limit exceeded. Please remove {characterCount -
                10000}{" "}
              character(s).
            </CharLimitExceeded>
          )}
          <Buttons>
            <SaveButton
              disabled={characterCount > 10000}
              data-test-id="about-company-save-button"
              onClick={this.handleSubmit}
            >
              save
            </SaveButton>
          </Buttons>
        </Form>
      </Wrapper>
    );
  }
}

AboutCompanyEdit.propTypes = {
  toggleEditAboutCompany: PropTypes.func.isRequired,
  submitUpdate: PropTypes.func.isRequired,
  aboutCompany: PropTypes.string,
  companyId: PropTypes.number,
};

AboutCompanyEdit.defaultProps = {
  aboutCompany: PropTypes.isNull,
  companyId: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  aboutCompany: state.agencyProfile.profileData.aboutCompany,
  companyId: state.agencyProfile.profileData.user.companyId,
});

export default connect(mapStateToProps, { submitUpdate })(AboutCompanyEdit);
